//Loại mẫu
export default {
  Template: 1,
  Designed : 0
};
